import {
    MembershipFieldsFragment,
    PromotionCodeFieldsFragment,
} from '@common/graphql/generated';
import { dt } from '@common/util/dateTime';
import { loadStripe } from '@stripe/stripe-js';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
export const stripePromise = loadStripe(
    process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY as string
);

export const getBillStr = (membership: MembershipFieldsFragment) => {
    if (membership?.status === 'CANCELED') {
        return 'Canceled';
    } else if (membership?.status === 'INCOMPLETE_EXPIRED') {
        return 'Expired';
    } else if (membership?.cancelAtPeriodEnd) {
        return `Ends on ${getMembershipNextBillingDateStr(membership)}`;
    } else {
        return `Billed ${membership.status === 'TRIALING' ? 'starting on' : 'on'} ${getMembershipNextBillingDateStr(membership)}`;
    }
};

export const getMembershipNextBillingDateStr = (
    membership: MembershipFieldsFragment
) => dt(membership.currentPeriodEndAt).format('MM/DD/YY');

export const getDaysUntilTrialEnds = (membership: MembershipFieldsFragment) => {
    const daysLeft = Math.ceil(
        dt(membership.freeTrialEndAt).diff(dt(), 'days', true)
    );
    return daysLeft < 0 ? 0 : daysLeft;
};

export const calculatePriceAfterPromotion = ({
    price,
    promotionCode,
}: {
    price: number;
    promotionCode: Pick<
        PromotionCodeFieldsFragment,
        'amountOff' | 'percentOff'
    >;
}) => {
    if (promotionCode.amountOff) {
        return price - promotionCode.amountOff;
    } else if (promotionCode.percentOff) {
        return Math.round(price * (1 - promotionCode.percentOff / 100));
    } else {
        console.error(
            'Expected promotionCode to have either amountOff or percentOff'
        );
        return price;
    }
};
